import React from 'react';
import { hot } from 'react-hot-loader/root';
import { ThemeProvider } from '@material-ui/core/styles';
import {
  Box,
  CssBaseline,
  // Link,
  Typography,
} from '@material-ui/core';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import theme from './theme';
import { ResearchPage } from './ResearchPage';

const App = () => {
  const isSmall = useMediaQuery('(max-width:600px)');
  const isMedium = useMediaQuery('(max-width:960px)');

  let size = 'large';
  if (isSmall) {
    size = 'small';
  } else if (isMedium) {
    size = 'medium';
  }

  const headerFontSize = isSmall ? 22 : 28;
  const dividerFontSize = isSmall ? 12 : 18;

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box
        display="flex"
        flexDirection="column"
        minHeight="100vh"
        bgcolor={theme.palette.background.default}
      >
        <Box
          component="header"
          display="flex"
          flexDirection={isSmall ? 'column' : 'row'}
          justifyContent="space-between"
          alignItems="center"
          alignSelf="center"
          px={isSmall ? 2 : 0}
          py={isSmall ? 3 : 6}
          style={
            isSmall
              ? undefined
              : { width: 'calc(100% - 32px)', maxWidth: 1200 }
          }
        >
          <Box
            display="flex"
            alignItems="center"
            flexDirection="row"
            mb={isSmall ? 2 : 0}
          >
            <Typography
              style={{
                fontSize: headerFontSize,
                fontWeight: 700,
                marginRight: 8,
                color: theme.customColors.heavy,
              }}
            >
              HYUNSUNG CHO
            </Typography>
            <Typography
              style={{
                fontSize: dividerFontSize,
                fontWeight: 200,
                color: theme.customColors.brand,
                marginRight: 8,
              }}
            >
              |
            </Typography>
            <Typography
              style={{
                fontSize: headerFontSize,
                fontWeight: 700,
                color: theme.customColors.heavy,
              }}
            >
              조현성
            </Typography>
          </Box>
          {/*
          <Box
            component="nav"
            display="flex"
            flexDirection="row"
            flexWrap="wrap"
            alignItems="center"
          >
            {[
              { label: 'About', href: '#about' },
              // { label: 'Research', href: '#research' },
              { label: 'Publications', href: '#publications' },
              { label: 'Recognitions & Service', href: '#service' },
            ].map((item) => (
              <Link
                key={item.href}
                href={item.href}
                style={{
                  fontSize: isSmall ? 13 : 15,
                  fontWeight: 600,
                  color: theme.customColors.heavy,
                  textDecoration: 'none',
                  marginRight: 20,
                  letterSpacing: 0.3,
                }}
              >
                {item.label}
              </Link>
            ))}
          </Box>
          */}
        </Box>
        <Box flexGrow={1} display="flex">
          <ResearchPage size={size} />
        </Box>
      </Box>
    </ThemeProvider>
  );
};

export default hot(App);
